import React, { lazy, Suspense, useEffect } from "react";
import "./GrowthOpportunities.css";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchGrowthOppurtunityByAccNclientRequest } from "../../../../store/features/actions/growthOpportunitiesByAccountAndClientActions";
import { fetchNewProjectRequest } from "../../../../store/features/actions/newProjectsActions";
const GrowthOpportunitiesBlock = lazy(() => import('./GrowthOpportunitiesBlock'))

export default function GrowthOpportunities({ active_tab_key }) {
  const { accountId, accountName, clientName } = useParams();
  const dispatch = useDispatch();
  const { account_info } = useSelector(state=>state?.accountsReducer);
  let ticker = account_info?.ticker;

  useEffect(() => {
    if (accountId && accountName && clientName) {
      dispatch(
        fetchGrowthOppurtunityByAccNclientRequest({
          accountId,
          accountName,
          clientName,
        })
      );
    }

    if (ticker) {
      dispatch(fetchNewProjectRequest(ticker))
    }
   
  }, [accountId, accountName, clientName,ticker]);

  return (
    <div className="">
      <div className="container-fluid">
        <div className="row">
        <Suspense fallback={null}>
          <GrowthOpportunitiesBlock active_tab_key={active_tab_key} />
        </Suspense>
        </div>
      </div>
    </div>
  );
}
